var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mob_guide_wwap"},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.apiObj.VUE_APP_BASE_CDN + _vm.guide),expression:"apiObj.VUE_APP_BASE_CDN + guide"}],staticClass:"mob_guide_img"})])
}
var staticRenderFns = []

export { render, staticRenderFns }